import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { pushToDataLayer } from 'utils/analytics';

export const usePageLoadTime = (): void => {
  const { pathname } = useLocation();
  const renderStartRef = useRef<number>(performance.now());
  const previousPathnameRef = useRef<string>(pathname);
  const isFirstRender = useRef(true);

  if (pathname !== previousPathnameRef.current) {
    renderStartRef.current = performance.now();
    previousPathnameRef.current = pathname;
  }

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      const [navigation] = performance.getEntriesByType(
        'navigation',
      ) as PerformanceNavigationTiming[];

      if (navigation) {
        pushToDataLayer({
          event: 'page_load_time',
          event_time: new Date().toISOString(),
          page_path: pathname,
          load_duration_ms: Math.round(navigation.domContentLoadedEventEnd),
          load_type: 'initial',
        });
      }
      return;
    }

    const loadDuration = performance.now() - renderStartRef.current;

    pushToDataLayer({
      event: 'page_load_time',
      event_time: new Date().toISOString(),
      page_path: pathname,
      load_duration_ms: Math.round(loadDuration),
      load_type: 'spa_navigation',
    });
  }, [pathname]);
};
